import React from 'react'
import * as FaIcons from 'react-icons/fa'
import * as MdIcons from 'react-icons/md'
import '../../assets/css/stylesheets/components/card/HorizontalEntryCard.css'

function HorizontalStaffCard({ staffMember }) {

    const imageSrc = `data:image/jpeg;base64,${staffMember.Picture}`;
    const myStyle = {
        backgroundImage: `url(${imageSrc})`,
        backgroundSize: 'contain', // Example: scales image to cover the entire container
        backgroundRepeat: 'no-repeat', // Example: prevents image repetition
        backgroundPosition: 'center', // Example: centers the image within the container
        backgroundColor: 'white' // Fallback color
  }

    return (
        <div className='horizontalentrycard'>
            <div className='horizontalentrycard-media' style={myStyle}>
            </div>
            <div className='horizontalentrycard-content'>
                <div className='horizontalentrycard-content-title'>
                    {staffMember.FirstName} {staffMember.LastName}
                </div>
                <div className='horizontalentrycard-content-description'>
                    {staffMember.PositionTitle}
                </div>
                <div>
                    {
                        staffMember.WorkPhone ? (
                            <div>
                                <MdIcons.MdWork className='horizontalentrycard-content-contact-icon' />
                                {staffMember.WorkPhone}
                            </div>) : (
                            <></>
                        )
                    }
                    {
                        staffMember.CellPhone ? (
                            <div>
                                <FaIcons.FaMobileAlt className='horizontalentrycard-content-contact-icon' />
                                {staffMember.CellPhone}
                            </div>) : (
                            <></>
                        )
                    }
                    {
                        staffMember.Email ? (
                            <div>
                                <MdIcons.MdMail className='horizontalentrycard-content-contact-icon' />
                                <a href={`mailto:${staffMember.Email}`}>{staffMember.Email}</a>
                            </div>
                        ) : (
                            <></>
                        )
                    }
                    {
                        staffMember.Fax ? (
                            <div>
                                <FaIcons.FaFax className='horizontalentrycard-content-contact-icon' />
                                {staffMember.Fax}
                            </div>) : (
                            <></>
                        )
                    }
                </div>
                <div className='horizontalentrycard-seperator'></div>
                <div className='horizontalentrycard-quick-actions'>
                    {
                        staffMember.LinkedInURL ? (
                            <a href={staffMember.LinkedInURL} target='blank' rel='noopener'>
                                <FaIcons.FaLinkedinIn />
                            </a>) : (
                            <></>
                        )
                    }
                </div>
            </div>
        </div>
    )
}

export default HorizontalStaffCard